<template>
    <v-container>
        <v-card class="dt-border pad-10" flat>
            <v-container>
                <v-row class="pa-5 mb-5">
                    <div>
                        <h2>Manage Notifications</h2>
                        <p>Manage Users Application notifications</p>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                        <createnotification-modal v-if="can('can_create_notification')" @reload="reload"/>
                    </div>
                </v-row>
                <v-row class="pl-5">
                <div>
                    <span v-if="details.total != 0 && this.loading == false" class="dt-orange white--text pa-2 rounded">{{details.total}} Notification</span>
                </div>
                <v-spacer></v-spacer>
                <dtunes-pagination
                    @reload="reload"
                    @nextPage="pageChangeHandle('next')"
                    @previousPage="pageChangeHandle('previous')"
                    :rows="rows"
                    :limit="limit"
                    :page="page"
                    :totalPage="totalPage"
                />
                </v-row>
                <br>
                <dtunes-loader :loading="loading"></dtunes-loader>
                <notifications-table @reload="reload" v-if="!loading" :details="details"/>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
import DtunesLoader from "@/components/dtunes-loader.vue"
import NotificationsTable from '../component/notifications-table.vue'
import CreatenotificationModal from '../component/create-notification-modal.vue';
import DtunesPagination from "@/components/dtunes-pagination.vue"
import { AppService } from "@/services";

export default {
    data:()=>({
        details:{},
        loading:false,
        rows:[20,50,100],
        totalPage:0,
        limit:20,
        page:1,
    }),
    components:{
        CreatenotificationModal,
        NotificationsTable,
        DtunesLoader,
        DtunesPagination
    },
    mounted(){
        this.getNotifications();
    },
    methods:{
        async getNotifications(){
            this.loading = true;
            const data = await AppService.getNotifications({
                page : this.page,
                limit : this.limit,
            });
            this.details = data
            this.loading = false
            this.totalPage = Math.ceil(this.details.total / this.limit)
        },
        async reload(value){
            if(value){
              this.limit = value
            }
            await this.getNotifications();
        },
        async pageChangeHandle(value) {
          switch (value) {
            case 'next':
              this.page += 1
              break
            case 'previous':
              this.page -= 1
              break
            default:
              this.page = value
          }
          this.getTransactions();
        }
    }
}
</script>